export default __webpack_public_path__ + "static/media/rarity6.15f32790.mp4";